import { fi, enGB, de, sv } from 'date-fns/locale';

export const ENGLISH = 'en';
export const FINNISH = 'fi';
export const GERMAN = 'de';
export const SWEDISH = 'sv';

export const VALID_LOCALES = [ENGLISH, FINNISH, GERMAN, SWEDISH];
// On  production, default locale is FI, to accomodate
// default language when url is `bestpark.fi` instead of
// `bestpark.fi/fi`.
export const DEFAULT_LOCALE = FINNISH;

export const TRANSLATIONS = [
  {
    name: 'In English',
    value: 'en',
  },
  {
    name: 'Suomeksi',
    value: 'fi',
  },
  {
    name: 'Auf Deutsch',
    value: 'de',
  },
  {
    name: 'Svenska',
    value: 'sv',
  },
];

export const DATE_LOCALES = [
  { lang: ENGLISH, locale: enGB },
  { lang: FINNISH, locale: fi },
  { lang: GERMAN, locale: de },
  { lang: SWEDISH, locale: sv },
];
